import client from './client';

export interface Notification {
  _id: string;
  actorName?: string;
  type: 'like' | 'comment' | 'bookmark';
  albumId: string;
  albumTitle?: string;
  preview?: string;
  read: boolean;
  createdAt: string;
}

export const getNotifications = async (): Promise<Notification[]> => {
  const res = await client.get('/notifications');
  return res.data;
};

export const getUnreadCount = async (): Promise<number> => {
  const res = await client.get('/notifications/unread-count');
  return res.data.count;
};

export const markAsRead = async (id: string): Promise<void> => {
  await client.post(`/notifications/${id}/read`);
};

export const markAllAsRead = async (): Promise<void> => {
  await client.post('/notifications/read-all');
};
